import { faCalendar, faSave } from '@fortawesome/free-solid-svg-icons'
import React, { useContext, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import {
  Avatar,
  Content,
  Data,
  Form,
  Layout,
  Navigation,
  Responsive,
  Search,
} from 'ui'
import { truncate } from 'utils'
import { CreateReportModal } from '../ReportsView/CreateReportModal'
import { usePaginatedInvitations } from './usePaginatedInvitations'
import { faUser } from '@fortawesome/free-solid-svg-icons'

const { Table, Cell, Row, Header } = Data

export const InvitationsListView: React.FC = () => {
  const { useDisplayMode } = useContext(Responsive.DrawerManagerContext)
  useDisplayMode('expanded')
  const {
    currentPage,
    error,
    loading,
    invitations,
    handlePageClick,
    pageCount,
    queryString,
    setQueryString,
    facets,
    toggleFacet,
    appliedFacets,
  } = usePaginatedInvitations({})

  const navigate = useNavigate()

  // Manage modal...
  const [showModal, setShowModal] = useState(false)
  const [modalLoading, setModalLoading] = useState(false)
  const dismissModal = () => setShowModal(false)

  // Handle report creation
  const canCreateReport =
    appliedFacets.length > 0 || (queryString?.length ?? 0) > 0
  const handleCreateReportClick = () => setShowModal(true)
  // const [createReport] = useCreateReportMutation()
  const handleCreateReport = async (name: string, description: string) => {
    setModalLoading(true)
    // await createReport({
    //   variables: {
    //     payload: {
    //       name,
    //       description,
    //       queryString,
    //       facetFilters: appliedFacets,
    //       indexType: ReportIndexType.Invitations,
    //     },
    //   },
    // })
    setModalLoading(false)
    setShowModal(false)
    navigate(`/admin/reports`)
  }

  return (
    <Layout.PaddedContent>
      <Helmet>
        <title>Invitations - MCSS Pro Connect</title>
      </Helmet>
      <div
        className="flex-col flex w-full"
        style={{ opacity: loading ? 0.5 : 1 }}
      >
        <div className="flex-col flex sm:flex-row flex">
          <div className="w-full sm:w-1/2">
            <Content.Heading>Invitations</Content.Heading>
          </div>
          <div className="ml-0 sm:ml-auto mt-3 sm:mt-auto w-full">
            <div className="ml-auto flex">
              <Content.ActionButton
                icon={faSave}
                label="Create Report"
                disabled={!canCreateReport}
                onClick={handleCreateReportClick}
              />
            </div>
          </div>
        </div>
        <div className="flex-col flex sm:flex-row flex">
          <div className="w-full sm:w-1/3 md:w-1/4 mr-0 sm:mr-2">
            <Search.FiltersCard
              onToggle={toggleFacet}
              onQuery={setQueryString}
              facets={facets ?? {}}
              appliedFacets={appliedFacets}
              initialQueryString={queryString}
              maxFilterBeforeReveal={5}
            />
          </div>
          <div className="w-full sm:w-2/3 md:w-3/4">
            <Table>
              <Row>
                <Header width="30%" className="!text-secondary">
                  Name / Company
                </Header>
                <Header width="30%" className="!text-secondary">
                  Event Name
                </Header>
                <Header width="20%" className="!text-secondary">
                  Status
                </Header>
                <Header width="5%" className="!text-secondary">
                  &nbsp;
                </Header>
                <Header width="5%" className="!text-secondary">
                  &nbsp;
                </Header>
              </Row>
              {invitations ? (
                invitations.map((e) => (
                  <Row key={e?.id}>
                    <Cell width="30%">
                      <div>
                        <Avatar.Simple
                          name={`${e?.profileName}`}
                          maxInitials={1}
                          size={36}
                          color={e?.profileColor ?? undefined}
                        />
                        <div className="my-auto pl-2 flex-col flex">
                          <p className="font-bold text-xs">
                            {truncate(e?.profileName ?? '', 20)}
                          </p>
                          <p className="text-xs">
                            {truncate(e?.profileDescription2 ?? '', 20)}
                          </p>
                        </div>
                      </div>
                    </Cell>
                    <Cell width="30%">{truncate(e?.eventName ?? '', 50)}</Cell>
                    <Cell width="20%">{e?.status}</Cell>
                    <Cell width="5%">
                      <Navigation.IconLink
                        icon={faUser}
                        to={`/admin/profiles/show/${e?.profileId}`}
                      />
                    </Cell>
                    <Cell width="5%">
                      <Navigation.IconLink
                        icon={faCalendar}
                        to={`/admin/events/show/${e?.eventId}`}
                      />
                    </Cell>
                  </Row>
                ))
              ) : error ? (
                <Row>
                  <p>
                    {error.message ??
                      'There was a problem fetching invitations.'}
                  </p>
                </Row>
              ) : (
                <Row>
                  <Cell>No results found.</Cell>
                </Row>
              )}
            </Table>
          </div>
        </div>
      </div>
      {loading ? null : (
        <Navigation.SimplePaginationBar
          onPageClick={handlePageClick({ historyPush: true })}
          currentPage={currentPage ?? 0}
          pageCount={pageCount ?? 0}
        />
      )}
      {showModal ? (
        <CreateReportModal
          confirmLabel="Create Report"
          loading={modalLoading}
          onConfirm={handleCreateReport}
          onDismiss={dismissModal}
          title="Save this Report"
          placeholder="Enter a name for this"
        />
      ) : null}
    </Layout.PaddedContent>
  )
}
